import { useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { ButtonMob, instance, Loadingspinner } from "../../../utils/utils";
import { ReactComponent as TrophyIcon } from "../../../assets/elevva-pro-icons/blueTrophy.svg";
import moment from "moment";
import imageDefault from "../../../assets/corporative/imageDefault.png";
import { DropdownList } from "react-widgets/cjs";
import { ReactComponent as ArrowDown } from "../../../assets/elevva-pro-icons/arrowDown.svg";
import { ReactComponent as Congratulations } from "../../../assets/elevva-pro-icons/congratsIcon.svg";

const ChallengeWinnerCard = ({
  challenge,
  buttonConfirmText,
  buttonCancelText,
  buttonsWidth,
  onConfirm,
  onCancel,
}) => {
  const iconStyle = {
    cursor: "pointer",
    marginLeft: "0.5rem",
    color: "blue",
    fontSize: "2rem",
  };

  const [participants, setParticipants] = useState([]);
  const [userSelected, setUserSelected] = useState([]);
  const [loader, setLoader] = useState(false);
  const [level, setLevel] = useState(0);
  const [challengeData, setChallengeData] = useState({});

  function getParticipants(level = null) {
    setLoader(true);
    instance
      .get(
        `customers/corp/challenges/${challenge.id}/participants${
          level ? `/?level=${level}` : ""
        }`
      )
      .then((res) => res.data)
      .then((data) => {
        let data_results = data?.results;
        let participants = data_results?.participants;
        data_results && setParticipants(participants);
        setChallengeData(data.results);
        const winners = challenge.participants
          .filter((participant) => participant.won)
          .map((participant) => participant.id);
        setUserSelected(winners);
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setLoader(false);
      });
  }
  useEffect(() => {
    getParticipants();
  }, [challenge.id]);
  useEffect(() => {
    setUserSelected([]);
    getParticipants(level);
  }, [level]);

  const duration = moment.duration(challengeData.time_remaining, "minutes");

  const days = Math.floor(duration.asDays());
  const hours = duration.hours();
  return (
    <div className="d-flex justify-content-between flex-column">
      <div className="d-flex flex-column align-items-center ">
        <span style={iconStyle} onClick={() => {}} className="my-2">
          <TrophyIcon />
        </span>
        <h5 className="mb-1">Usuarios inscritos</h5>
        <h5 className="mb-1">Elige al ganador</h5>
        <h6 className="mb-1">{challengeData.title}</h6>

        <p>
          <span
            className="dashboard-input"
            style={{ color: "var(--elevvaTextSubtitle)" }}
          >
            <i className="bi bi-stopwatch"></i> Tiempo restante:
          </span>{" "}
          {days == 0 ? (
            <span className="dashboard-input">
              {hours} {hours === 1 ? "hora" : "horas"}
            </span>
          ) : (
            <span className="dashboard-input">
              {days} {days === 1 ? "día" : "días"} {hours}{" "}
              {hours === 1 ? "hora" : "horas"}
            </span>
          )}
        </p>
      </div>
      {participants && (
        <DropdownList
          busy
          required
          name="score_for_participating"
          busySpinner={<ArrowDown />}
          className={"input-style-elevva-challenge mb-4"}
          id="newScrollChallenge"
          placeholder={"Selecciona el nivel"}
          data={[0, 10, 20, 30].map((memb) => ({
            id: memb,
            name:
              memb == 10
                ? "Principiante"
                : memb == 20
                ? "Intermedio"
                : memb == 30
                ? "Avanzado"
                : "Todos",
          }))}
          dataKey="id"
          textField="name"
          onChange={(value) => setLevel(Number(value.id))}
          renderListItem={({ item }) => (
            <div
              className="w-100 py-1"
              style={{ borderBottom: "1px solid #9DACBD" }}
            >
              <div
                className=" dashboard-input fw-bold"
                style={{ color: "var(--elevvaTextSubtitle)" }}
              >
                {item.name}
              </div>
            </div>
          )}
        />
      )}

      {loader ? (
        <div className="d-flex justify-content-center">
          <Loadingspinner size="2.5rem" />
        </div>
      ) : (
        <PerfectScrollbar
          className="d-flex flex-column gap-2 px-2"
          style={{ maxHeight: "15rem" }}
        >
          {participants.length > 0 ? (
            participants?.map((user) => (
              <div
                className="d-flex gap-2 align-items-center  mx-auto py-3 mb-1 justify-content-start"
                style={{
                  border: "1px solid var(--elevvaTextSubtitle)",
                  borderRadius: "20px",
                  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                  maxWidth: "18rem",
                  width: "100%",
                }}
              >
                <label className="ms-3 custom-checkbox">
                  <input
                    type="checkbox"
                    name="user"
                    checked={userSelected.includes(user.id)}
                    onClick={() =>
                      setUserSelected((prev) => {
                        if (prev.includes(user.id)) {
                          return prev.filter((item) => item !== user.id);
                        }
                        return [...prev, user.id];
                      })
                    }
                  />
                  <span className="checkmark"></span>
                </label>
                <div>
                  <img
                    style={{
                      width: "34px",
                      height: "34px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                    src={user?.photo || imageDefault}
                    alt="imaagee_deefault"
                  />
                </div>
                <div
                  className="size-table-users d-flex flex-column"
                  style={{ textAlign: "left" }}
                >
                  <span
                    className="dashboard-input"
                    style={{ color: "var(--elevvaTextSubtitle)" }}
                  >
                    Inscrito el: {moment(user.join_at).format("DD/MM/YY")}
                  </span>
                  <span className="dashboard-input">{user.name}</span>
                </div>
              </div>
            ))
          ) : (
            <div>
              <span>No encontrados</span>
            </div>
          )}
        </PerfectScrollbar>
      )}

      <div
        className="d-flex justify-content-center gap-2 mx-auto"
        style={{ width: buttonsWidth }}
      >
        <ButtonMob
          handleClick={onCancel}
          colorButton={"transparent"}
          colorTextButton={"var(--elevvabutonLogin_User)"}
          borderbutton="1px solid var(--elevvabutonLogin_User)"
          text={buttonCancelText}
          className={"  px-2"}
          sizeFont=" calc(0.3rem + 0.3vw)"
        />

        <ButtonMob
          handleClick={() => onConfirm(userSelected)}
          colorButton={"var(--elevvabutonLogin_User)"}
          text={buttonConfirmText}
          className={"px-2"}
          sizeFont=" calc(0.3rem + 0.3vw)"
        />
      </div>
    </div>
  );
};

export default ChallengeWinnerCard;
